import React, { useState } from 'react'
import { Tabs } from 'antd'
import SlideImage from '../components/SlideImage/SlideImage'
import Poster from '../components/Slide/Poster'
import { hasPermission } from '../config-func'
const SlideImagePage = () => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const items = [
    {
      key: '1',
      label: 'Quản lý slide ảnh',
      children: <SlideImage />
    },
    {
      key: '2',
      label: 'Tạo ảnh',
      children: hasPermission('P61.4', permissions) ? <Poster /> : 'Bạn không có quyền truy cập vào trang này'
    }
  ]
  return (
    <>
      <Tabs defaultActiveKey="1" items={items} />
    </>
  )
}

export default SlideImagePage
